import React from 'react';
import profilePhoto from '../images/Dmitriy_Profile.jpg';
import './About.css';

export default function About() {
  return (
    <section className="about" id="about">
      <div className="about__inner">

        <div className="section-header">
          <p className="section-label">About</p>
          <h2 className="section-title">Dmitriy Filimonov</h2>
          <div className="section-rule">
            <span className="section-rule__line" />
            <span className="section-rule__diamond" />
            <span className="section-rule__line" />
          </div>
        </div>

        <div className="about__content">

          {/* Stationery bio card */}
          <div className="about__stationery">

            {/* Paper header */}
            <div className="about__paper-head">
              <div className="about__paper-rule" />
              <p className="about__paper-label">About the Author</p>
              <div className="about__paper-rule" />
            </div>

            {/* Author photo */}
            <div className="about__photo-frame">
              <div className="about__photo-corner about__photo-corner--tl" />
              <div className="about__photo-corner about__photo-corner--tr" />
              <div className="about__photo-corner about__photo-corner--bl" />
              <div className="about__photo-corner about__photo-corner--br" />
              <img
                src={profilePhoto}
                alt="Dmitriy Filimonov"
                className="about__photo"
              />
            </div>

            {/* Bio text */}
            <div className="about__bio-text">
            <p>
              I came out of the University of California, Merced with a degree in
              Computer Science and Engineering, having spent my time learning how
              to build software that actually performs when real people hit the
              buttons. My work sits at the intersection of systems programming,
              full-stack development, and autonomous AI, built on a simple
              premise: not merely writing code that works on my own desk, but
              delivering infrastructure with the architectural integrity and
              production-grade reliability that keeps an operation running. You
              won&rsquo;t find much patience in my work for high-sounding jargon
              or technical fluff; I prefer getting down to the raw mechanics of a
              problem and building software that stays built.
            </p>
            <p>
              Most recently, a pomegranate farm hired our outfit; we had four
              engineers in total to sort out their entire record-keeping
              operation. We didn&rsquo;t begin by throwing tech stacks at them; we
              sat down with the fellows who actually run the orchards and
              listened. Your average farmer knows what he needs a good deal better
              than any engineer; he just doesn&rsquo;t express himself in schema.
              Once we got the lowdown in plain American, we chucked their old
              hand-tracking system out the window and built a full traceability
              pipeline together. While the team delivered an offline mobile app
              and authentication for the field hands, I architected the underlying
              engine: a PostgreSQL schema locking in the full chain of custody, a
              30-test suite to keep the infrastructure bulletproof, and an
              automated Python tool that delivers Excel reports formatted exactly
              the way their foremen want them. My approach is diagnostic from the
              start: I identify the root structure of a problem before writing the
              first line of code, which solves the real operational headache and
              saves a lot of beautiful cussing later on.
            </p>
            <p>
              Security isn&rsquo;t an afterthought I tack on at the end, but a
              core requirement woven through everything I build. That work ranges
              from engineering a cryptographic file-sharing system in Go over at
              UC Berkeley, to systematically finding vulnerabilities and hardening
              Content-Security-Policies across production systems before flaws
              turn into costly incidents.
            </p>
            <p>
              Outside of software, I hold a 5th Degree Black Belt and have spent
              years instructing others in the trade. That experience taught me
              precisely how to keep my shirt on when a project goes sideways,
              mentor team members under pressure, and keep the whole outfit moving
              cleanly toward the goal.
            </p>
            </div>

            {/* Signature line */}
            <div className="about__signature">
              <div className="about__paper-rule about__paper-rule--short" />
              <p className="about__sig-name">Dmitriy V. Filimonov</p>
              <p className="about__sig-title">Santa Clara, California &nbsp;·&nbsp; {new Date().getFullYear()}</p>
            </div>

          </div>

          {/* Detail panel */}
          <div className="about__details">
            <div className="about__detail-item">
              <span className="section-label">Education</span>
              <p className="about__detail-value">B.S. Computer Science &amp; Engineering</p>
              <p className="about__detail-sub">UC Merced &nbsp;·&nbsp; 2026</p>
              <p className="about__detail-value">UC Berkeley &nbsp;·&nbsp; Summer 2026</p>
              <p className="about__detail-sub">CS161: Computer Security</p>
            </div>
            <div className="about__detail-divider" />
            <div className="about__detail-item">
              <span className="section-label">Location</span>
              <p className="about__detail-value">Santa Clara, CA</p>
            </div>
            <div className="about__detail-divider" />
            <div className="about__detail-item">
              <span className="section-label">Relevant Coursework</span>
              <p className="about__detail-value">Data Structures &nbsp;·&nbsp; Operating Systems</p>
              <p className="about__detail-value">Computer Architecture &nbsp;·&nbsp; Databases</p>
              <p className="about__detail-value">Computer Vision &nbsp;·&nbsp; Computer Security</p>
            </div>
            <div className="about__detail-divider" />
            <div className="about__detail-item">
              <span className="section-label">Distinction</span>
              <p className="about__detail-value">5th Degree Black Belt</p>
              <p className="about__detail-sub">Ernie Reyes West Coast World Martial Arts</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}